import {
	API_ROUTES,
	DEALER_FROZEN_DISALLOWED_ROUTES,
	EXTERNAL_ROUTES,
	IGNORED_FROM_HISTORY_ROUTES,
	PROTECTED_ROUTES,
	PUBLIC_ROUTES,
	ROUTES,
	SCROLL_TOP_USING_AS_PATH_CHANGE_ROUTES,
} from '@motorway/mw-dealer-shared-components/utils';

export {
	API_ROUTES,
	DEALER_FROZEN_DISALLOWED_ROUTES,
	EXTERNAL_ROUTES,
	IGNORED_FROM_HISTORY_ROUTES,
	PROTECTED_ROUTES,
	PUBLIC_ROUTES,
	ROUTES,
	SCROLL_TOP_USING_AS_PATH_CHANGE_ROUTES,
};

export default ROUTES;
